import { render, staticRenderFns } from "./InputColor.vue?vue&type=template&id=66c07913&"
import script from "./InputColor.vue?vue&type=script&lang=js&"
export * from "./InputColor.vue?vue&type=script&lang=js&"
import style0 from "./InputColor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports